import script from "./TemplateToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateToolbar.vue?vue&type=script&setup=true&lang=js"

import "./TemplateToolbar.vue?vue&type=style&index=0&id=b589712e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b589712e"]])

export default __exports__